import { IonButton, IonIcon, IonRow } from "@ionic/react";
import React, { FC } from "react";
import CheckRole from "../extras/CheckRole";
import { useAppSelector } from "../../Hooks";
import { selectUser } from "../../reducers/UserReducer";
import { personAddSharp } from "ionicons/icons";

interface IProps {}

const AddCustomerButton: FC<IProps> = (props) => {
  const user = useAppSelector(selectUser);
  return (
    <IonRow
      hidden={!CheckRole(user, ["Supervisor", "Admin", "Employee"])}
      className="ion-justify-content-end"
    >
      <IonButton
        style={{ "--background": "#10397ebd" }}
        href="/customer"
        title="Create Customer"
        shape="round"
      >
        <IonIcon slot="icon-only" src={personAddSharp} />
      </IonButton>
    </IonRow>
  );
};

export default AddCustomerButton;
